import {MapState, PlayerColor} from '@colonist/game-states'
import {BotDifficulty} from '@colonist/game-base-types'

export enum RoomAction {
    RoomReadyToStart = 1,
    RoomSelectColor = 2,
    RoomStartGame = 3,
    RoomKickPlayer = 4,
    RoomAddBot = 5,
    RoomSettingChangePrivateGame = 6,
    RoomSettingChangeNoTrollsSetting = 7,
    RoomSettingUpdateGameModeSetting = 8,
    RoomSettingUpdateMapSetting = 9,
    RoomSettingUpdateDiceSetting = 10,
    RoomSettingChangeVictoryPointsToWin = 11,
    RoomSettingChangeCardDiscardLimit = 13,
    RoomSettingChangeFriendlyRobber = 14,
    RoomSettingChangeMaxPlayers = 15,
    RoomSettingChangeHideBankCards = 16,
    RoomSettingChangeGameSpeed = 17,
    RoomSettingChangeBotSpeed = 18,
    RoomChatSubmit = 19,
    RoomSetPremium = 20,
    RoomPayPremium = 21,
    RoomExit = 22,
    RoomSetBotDifficulty = 23,
    RoomSetSeedOrder = 24,
    RoomStartPlayOrderSelection = 25,
    RoomSetPlayOrder = 26,
    RoomSettingChangePlayOrderSelection = 27,
    RoomStartSeedOrderSelection = 28,
}

export enum RoomType {
    Standard,
    FreeMap,
    BeginnerMode,
    CustomLink,
    DiscordActivity,
    Tournament,
}

export const ROOM_PRIMARY_ACTIONS: readonly RoomAction[] = []
export const TOURNAMENT_ROOM_KEYWORDS: string[] = ['event', 'tourney', 'lbco'] // Keep keyword length <= 8

export interface RoomActionKickPlayerData {
    roomSessionId: string
}

export interface RoomActionSetColorData {
    roomSessionId: string
    color: PlayerColor
}

export interface RoomStartGameData {
    clientVersion: number
}

export interface RoomPlayOrderSelectionData {
    mapState: MapState
    currentSelector: PlayerColor
    playOrder: [PlayerColor, number][]
}

export interface RoomSeedOrderSelectionData {
    seedOrder: [number, PlayerColor][]
}

export interface RoomActionSetSeedOrder {
    color: PlayerColor
    order: number
}

export interface RoomActionSetPlayOrder {
    order: number
}

export interface RoomActionSetBotDifficultyData {
    roomSessionId: string
    botDifficulty: BotDifficulty
}
